import axios from "../../config/axiosConfig";
import {
  CREATE_JOB_YARN_RECEIVE, DELETE_JOB_YARN_RECEIVE,
  GET_JOB_YARN_RECEIVE,
  JOB_YARN_RECEIVE_REQUEST,
  JOB_YARN_RECEIVE_REQUEST_FAILURE,
  UPDATE_JOB_YARN_RECEIVE,
  GET_JOB_YARN_RECEIVES_PAGE,
  JOB_YARN_RECEIVE_REQUEST_SUCCESS
} from "../types/job-yarn-receive-types";


export const getJobYarnReceivesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Job_Id'
      };
      return axios.get("/job-yarn-receive/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_RECEIVES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJobYarnReceiveById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
    
      return axios.get(`/job-yarn-receive/get/${id}`).then((response) => {
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnReceiveBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/job-yarn-receive/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnReceivesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/job-yarn-receive/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJobYarnReceive = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/job-yarn-receive/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_RECEIVE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createJobYarnReceive = (jobYarnReceive) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      const newJobYarnReceive = {
        ...jobYarnReceive
      };
      return axios.post("/job-yarn-receive/add", newJobYarnReceive,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_JOB_YARN_RECEIVE, payload: response.data });
        } else {
          dispatch({
            type: JOB_YARN_RECEIVE_REQUEST_FAILURE,
            error: "Job Yarn Receive create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateJobYarnReceive = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.put("/job-yarn-receive/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_JOB_YARN_RECEIVE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: JOB_YARN_RECEIVE_REQUEST_FAILURE,
            error: "Job Yarn Receive update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteJobYarnReceive = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST });
      return axios.delete(`/job-yarn-receive/delete/${id}`).then((response) => {
        if (response.data) {
          const include = ['id', 'Entry_No', 'P_Challan_No', 'Date', 'Account_Id', 'Job_Id'].join(',');
          const searchCols = ['Entry_No'].join(',');
          const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.jobYarnReceive || {};
          dispatch(getJobYarnReceivesWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
          dispatch({ type: DELETE_JOB_YARN_RECEIVE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};